module.exports = __webpack_public_path__ + "static/assets/c9638c10d6e10f1691ea32a06b056d46.png";